import { Chakra } from "@airhelp/react-ui-components";
import { useLinkRelValue } from "hooks";
import NextLink from "next/link";
import type { LinkProps } from "./Link.d";

const { Link: ChakraLink } = Chakra;

const Link = ({ children, href, target, linktype, styles }: LinkProps) => {
  const relValue = useLinkRelValue(href, linktype);

  return (
    <NextLink href={href} passHref>
      <ChakraLink rel={relValue} target={target} sx={styles}>
        {children}
      </ChakraLink>
    </NextLink>
  );
};

export default Link;
